import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { RadioItem } from '@adc/ui-core'

const SubEntityFormHeader = props => {
  const { formKey, forms, handleItemClick, onSelectItem, openedFormIndex } =
    props

  if (forms.length < 2) {
    return null
  } else {
    return forms.map((form, index) => (
      <RadioItem
        name={`${formKey}.title`}
        checked={openedFormIndex === index}
        label={form.label}
        elmId={`${formKey}.${_.snakeCase(form.formType)}_form`}
        key={index}
        onClick={() => onSelectItem(handleItemClick, index, form.formType)}
      />
    ))
  }
}

SubEntityFormHeader.propTypes = {
  formKey: PropTypes.string.isRequired,
  forms: PropTypes.array.isRequired,
  handleItemClick: PropTypes.func.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  openedFormIndex: PropTypes.number.isRequired,
}

export default SubEntityFormHeader
